const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '项目基本情况',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/app/home/bgggDetail`, {
                ggGuid: this.$route.query.ggGuid,
            }, { showLoading: true }).then((res) => {
                this.config[1].options.data = {
                    '项目名称': res.data.bggg.gcName,
                    '项目编号': res.data.bggg.gcBH,
                    '项目类型': getProjectTypeName(res.data.bggg.xmLeiXing),
                    '采购方式': getPurchaseTypeName(res.data.bggg.zbFangShi),
                    '行业分类': '',
                    '招标人': res.data.bggg.qiYe_Name,
                }
                try {
                    const bgContent = JSON.parse(res.data.bggg.bgContent)
                    bgContent.forEach((item) => {
                        this.config.push(...[{
                            component: 'ZlmTitle',
                            options: {
                                size: 'medium',
                                text: item.name,
                            },
                        },
                        {
                            component: 'ZlmTabDetail',
                            options: {
                                title: '变更',
                                data: item.children.map((t) => ({
                                        '名称': t.name,
                                        '原始值': t.oldValue,
                                        '修改值': t.newValue,
                                    })),
                            },
                        }])
                    })
                } catch {
                    //
                }
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
